import Router from './Router';
import Middleware from './middleware/Middleware';
import withQueryMiddleware from './middleware/withQueryMiddleware';
import withRelativePath from './middleware/withRelativePath';
import withRedirect from './middleware/withRedirect';
import devTools from './middleware/devTools';
export function install(opts) {
  return new Router(opts.history, opts.routes, opts.getContext, withQueryMiddleware.concat(opts.middleware || Middleware.EMPTY).concat(withRedirect).concat(withRelativePath).concat(devTools) // devTools always has to be the last in case there are any config/node transforms
  );
}
export { default as RouterStore } from './model/RouterStore';
export { default as Router } from './Router';
export { EventTypes } from './events';
export { TransitionTypes } from './transition/types';
export { default as Middleware } from './middleware/Middleware';
export { default as transformConfigLoad } from './middleware/transformConfigLoad';
export { default as transformConfig } from './middleware/transformConfig';
export { default as transformEventType } from './middleware/transformEventType';
export { default as transformNavigation } from './middleware/transformNavigation';
export { default as devTools } from './middleware/devTools';
export { default as areRoutesEqual } from './model/util/areRoutesEqual';
export { RouteError, NotFound, Unauthorized, AuthenticationTimeout, BadRequest } from './errors';